<script>
  import { formatStr } from '../utils/format.js';
  import { colorScale } from '../utils/color.js';

  import { precinctBassPct, precinctCarusoPct } from '../store.js';
  import Photo from './Photo.svelte';
  export let precinct;
  export let data;
  export let precinctBounds;
  export let precinctPolyline;
  export let ccDistrictBounds;
  export let neighborhoodBounds;
  export let neighborhoodFirstBounds;
  export let neighborhoodSecondBounds;
  export let mapboxToken;

  let ccSrc =
    'https://api.mapbox.com/styles/v1/latimes/cla9w1v9r002u15o9smjz21e0/static/path-2+000-1+' +
    colorScale(data.vote_margin/100).replace('#', '') +
    '-1(' +
    precinctPolyline +
    ')/' +
    ccDistrictBounds +
    '/310x180@2x?padding=10&access_token=' +
    mapboxToken +
    '&setfilter=["==","district","' +
    data.district +
    '"]&layer_id=city-council-results&attribution=false&logo=false';

    let nbhSrc = 'https://api.mapbox.com/styles/v1/latimes/claa76m1z001c14mi31yfxjj4/static/path-2+000-1+' +
    colorScale(data.vote_margin/100).replace('#', '') +
    '-1(' +
    precinctPolyline+
    ')/' +
    neighborhoodBounds +
    '/310x180@2x?padding=-5&access_token=' +
    mapboxToken +
    '&setfilter=["==","neighborhood","' +
    data.neighborhood +
    '"]&layer_id=neighborhood-results&attribution=false&logo=false';

    let nbh1Src = 'https://api.mapbox.com/styles/v1/latimes/claa76m1z001c14mi31yfxjj4/static/'+neighborhoodFirstBounds+'/310x180@2x?padding=-5&access_token='+mapboxToken+'&setfilter=["==","neighborhood","'+data.first+'"]&layer_id=neighborhood-results&attribution=false&logo=false';

    let nbh2Src = 'https://api.mapbox.com/styles/v1/latimes/claa76m1z001c14mi31yfxjj4/static/'+neighborhoodSecondBounds+'/310x180@2x?padding=-5&access_token='+mapboxToken+'&setfilter=["==","neighborhood","'+data.second+'"]&layer_id=neighborhood-results&attribution=false&logo=false';

</script>

<div class="detail-group">
  {#if typeof data.vote_margin !== 'undefined'}
  <div class="detail-location-label precinct">
    <p class="detail-location-label__desc">Your precinct</p>
    <p class="detail-location-label__place">{precinct}</p>
  </div>
    <div class="results">
      <div class="candidate candidate-1">
        <div class="image-container">
          <div class="candidate-headshot">
            <Photo
              name={`Karen Bass`}
              img={'assets/images/bass.png'}
              webp={'assets/images/bass.webp'}
              party={'dem'}
              backgroundColor={'#8f68BB'}
            />
          </div>
        </div>
        <div class="text-left">
          <div class="candidate-name">Karen Bass</div>
          <div class="candidate-pct">{Math.round($precinctBassPct)}%</div>
        </div>
        <span class="winner" /><br />
      </div>
      <div class="candidate-divider" />
      <div class="candidate candidate-2">
        <div class="image-container">
          <div class="candidate-headshot">
            <Photo
              name={`Rick Caruso`}
              img={'assets/images/caruso.png'}
              webp={'assets/images/caruso.webp'}
              party={'dem'}
              backgroundColor={'#3A7364'}
            />
          </div>
        </div>
        <div class="text-left">
          <div class="candidate-name">Rick Caruso</div>
          <div class="candidate-pct">{Math.round($precinctCarusoPct)}%</div>
        </div>
      </div>
    </div>
  {:else}
    <div class="results">
      <div>Votes have not yet been recorded in this area.*</div> 
    </div>
  {/if}
</div>

<div class="detail-split">
  <div class="detail-map-group">
    <div class="detail-location">
      <div class="detail-location-map">
        <img src={ccSrc} alt="Precinct {precinct}." />
      </div>
    </div>
    <div class="text">
      <div class="detail-location-label">
        <p class="detail-location-label__desc">City Council District</p>
        <p class="detail-location-label__place">{data.district}</p>
      </div>
      <div class="results">
        <div class="candidate-1">
            <div>Bass</div>
            <div class="pct">{Math.round(data.ccdist_bass_pct * 100)}%</div>
        </div>
        <div class="divider"></div>
        <div class="candidate-2">
            <div>Caruso</div>
            <div class="pct">{Math.round(data.ccdist_caruso_pct * 100)}%</div>
        </div>
      </div>
    </div>
  </div>

  <div class="detail-map-group">
    <div class="detail-location">
      <div class="detail-location-map">
        <img src={nbhSrc} alt="Precinct {precinct}." />
      </div>
    </div>
    <div class="text">
      <div class="detail-location-label">
        <p class="detail-location-label__desc">Your neighborhood</p>
        <p class="detail-location-label__place">{data.neighborhood}</p>
      </div>
      <div class="results">
        <div class="candidate-1">
            <div>Bass</div>
            <div class="pct">{Math.round(data.nbh_bass_pct * 100)}%</div>
        </div>
        <div class="divider"></div>
        <div class="candidate-2">
            <div>Caruso</div>
            <div class="pct">{Math.round(data.nbh_caruso_pct * 100)}%</div>
        </div>
      </div>
    </div>
  </div>

  <div class="detail-map-group similar-neighborhoods">
    <div class="title">Neighborhoods like yours</div>
    <div class="detail-map-group1">
        <div class="detail-location">
          <div class="detail-location-map">
            <img src={nbh1Src} alt="Precinct {precinct}." />
          </div>
        </div>
        <div class="text">
          <div class="detail-location-label">
            {data.first}
          </div>
          <div class="results">
            <div class="candidate-1">
                <div>Bass</div>
                <div class="pct">{Math.round(data.first_sim_nbh_bass_pct * 100)}%</div>
            </div>
            <div class="candidate-2">
                <div>Caruso</div>
                <div class="pct">{Math.round(data.first_sim_nbh_caruso_pct * 100)}%</div>
            </div>
          </div>
        </div>
      </div>
    
      <div class="detail-map-group2">
        <div class="detail-location">
          <div class="detail-location-map">
            <img src={nbh2Src} alt="Precinct {precinct}." />
          </div>
        </div>
        <div class="text">
          <div class="detail-location-label">
            {data.second}
          </div>
          <div class="results">
            <div class="candidate-1">
                <div>Bass</div>
                <div class="pct">{Math.round(data.second_sim_nbh_bass_pct * 100)}%</div>
            </div>
            <div class="candidate-2">
                <div>Caruso</div>
                <div class="pct">{Math.round(data.second_sim_nbh_caruso_pct * 100)}%</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  
